import { render, staticRenderFns } from "./ModalTermsAndConditions.vue?vue&type=template&id=0f8e916a"
import script from "./ModalTermsAndConditions.vue?vue&type=script&lang=js"
export * from "./ModalTermsAndConditions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports